import React, { useMemo, useState } from 'react';
import './TestsPage.css';

const PLATES = [
  {
    id: 'plate-1',
    title: 'Planche 1',
    imageUrl: 'https://commons.wikimedia.org/wiki/Special:FilePath/Ishihara%201.svg',
    answer: '12',
    options: ['12', '17', '71', 'Rien'],
    notes: 'Planche de démonstration.',
  },
  {
    id: 'plate-2',
    title: 'Planche 2',
    imageUrl: 'https://commons.wikimedia.org/wiki/Special:FilePath/Ishihara%202.svg',
    answer: '2',
    options: ['2', '8', '5', 'Rien'],
    notes: 'Planche libre sur Wikimedia Commons.',
  },
  {
    id: 'plate-3',
    title: 'Planche 3',
    imageUrl: 'https://commons.wikimedia.org/wiki/Special:FilePath/Ishihara%203.jpg',
    answer: '6',
    options: ['6', '5', '8', 'Rien'],
    notes: 'Identifier le nombre perçu.',
  },
  {
    id: 'plate-4',
    title: 'Planche 4',
    imageUrl: 'https://commons.wikimedia.org/wiki/Special:FilePath/Ishihara%209.svg',
    answer: '74',
    options: ['74', '21', '14', 'Rien'],
    notes: 'Plaque historique vectorisée.',
  },
  {
    id: 'plate-5',
    title: 'Planche 5',
    imageUrl: 'https://commons.wikimedia.org/wiki/Special:FilePath/Ishihara%2011.PNG',
    answer: '6',
    options: ['6', '8', '9', 'Rien'],
    notes: 'Planches libres issues du domaine public / Commons.',
  },
  {
    id: 'plate-6',
    title: 'Planche 6',
    imageUrl: 'https://commons.wikimedia.org/wiki/Special:FilePath/Ishihara%2019.PNG',
    answer: '2',
    options: ['2', '42', '7', 'Rien'],
    notes: 'Planche additionnelle de dépistage.',
  },
  {
    id: 'plate-7',
    title: 'Planche 7',
    imageUrl: 'https://commons.wikimedia.org/wiki/Special:FilePath/Ishihara%2023.PNG',
    answer: '42',
    options: ['42', '23', '24', 'Rien'],
    notes: 'Lecture simple avec score final.',
  },
];

export default function IshiharaTestPage({ goTo }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [answers, setAnswers] = useState({});

  const currentPlate = PLATES[currentIndex];
  const isLast = currentIndex === PLATES.length - 1;

  const score = useMemo(() => {
    const correct = PLATES.filter((plate) => answers[plate.id] === plate.answer).length;
    return {
      correct,
      total: PLATES.length,
      percent: Math.round((correct / PLATES.length) * 100),
    };
  }, [answers]);

  const setAnswer = (value) => {
    setAnswers((prev) => ({ ...prev, [currentPlate.id]: value }));
  };

  const restart = () => {
    setAnswers({});
    setCurrentIndex(0);
  };

  return (
    <div className="test-shell">
      <div className="test-panel glass-card">
        <div className="test-topbar">
          <div>
            <h1>Test Ishihara</h1>
            <p>Planches libres intégrées via Wikimedia Commons.</p>
          </div>
          <div className="test-actions">
            <button onClick={() => goTo('tests')}>⬅ Tests</button>
            <button onClick={restart}>↺ Recommencer</button>
          </div>
        </div>

        <div className="ishihara-grid">
          <section className="ishihara-stage">
            <div className="ishihara-image-wrap">
              <img src={currentPlate.imageUrl} alt={currentPlate.title} />
            </div>
            <h2>{currentPlate.title}</h2>
            <p>{currentPlate.notes}</p>

            <div className="answer-grid">
              {currentPlate.options.map((option) => (
                <button
                  key={option}
                  type="button"
                  className={answers[currentPlate.id] === option ? 'active' : ''}
                  onClick={() => setAnswer(option)}
                >
                  {option}
                </button>
              ))}
            </div>
          </section>

          <aside className="ishihara-controls">
            <div className="control-stack">
              <p>
                <strong>Progression :</strong> {currentIndex + 1} / {PLATES.length}
              </p>
              <p>
                <strong>Réponse sélectionnée :</strong> {answers[currentPlate.id] || '—'}
              </p>
              <div className="test-actions">
                <button type="button" onClick={() => setCurrentIndex((prev) => Math.max(prev - 1, 0))}>
                  ⬅ Précédent
                </button>
                <button type="button" onClick={() => setCurrentIndex((prev) => Math.min(prev + 1, PLATES.length - 1))}>
                  {isLast ? 'Fin' : 'Suivant ➡'}
                </button>
              </div>

              <div className="score-card">
                <strong>Score actuel :</strong>
                <div>{score.correct} / {score.total}</div>
                <div>{score.percent}% de réponses exactes</div>
              </div>

              <p className="helper-note">
                Ce module sert de dépistage visuel dans l&apos;appli. Les réponses attendues sont paramétrées localement pour le scoring.
              </p>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
}
